import { Base } from "./base";

export class Vehicle extends Base {
    VehicleID?: string;
    IsDeleted?: boolean;
    Plate?: string;
    RegisterDate?: Date;
}